import { render, staticRenderFns } from "./FinancesReport.vue?vue&type=template&id=61b06a34"
import script from "./FinancesReport.vue?vue&type=script&lang=js"
export * from "./FinancesReport.vue?vue&type=script&lang=js"
import style0 from "./FinancesReport.vue?vue&type=style&index=0&id=61b06a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports